import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const OfferTask = lazy(() => import('./Offer.tsx'));

export const Offer: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<OfferTask {...props} />
	</Suspense>
);
